var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('router-link',{staticClass:"po-route-link",attrs:{"to":_vm.route,"target":_vm.target,"tabindex":_vm.tabindex}},[_c('wo-link',{class:_vm.linkClass,attrs:{"tag-name":"span"}},[_vm._v(_vm._s(_vm.routeLabel))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }